import { redirect } from "react-router";

import { routes } from "../config/routes";
import { isUserSessionActive } from "./isUserSessionActive";
import { getAccessToken, getAssignedDataGroup } from "./SecurityManager";

// Guards /login: an already-authenticated user landing here (e.g. a transient error in the
// login-completion pipeline bouncing them here despite still holding a valid session) should go
// straight to the dashboard instead of being asked to log in again. Also requires an assigned data
// group — without one, the app has no context to act in, so falling through to the login page
// (rather than dashboard) avoids redirecting into a state the rest of the app isn't ready for.
export const redirectIfAuthenticatedLoader = () => {
    if (getAccessToken() && isUserSessionActive() && getAssignedDataGroup()) {
        return redirect(routes.landingPage.path);
    }
    return null;
};
